import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory as createHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import createSagaMiddleware from 'redux-saga';

import { notify } from '../services/bugsnag';
import { shouldIgnore } from './error-ignore-list';
import rootReducer, { createRootReducer } from './root-reducer';
import rootSaga from './root-saga';

export let history = createHistory();

const sagaMiddleware = createSagaMiddleware({
  onError: (error) => {
    console.error('Saga Error:', error);
    notify(error);
  }, // eslint-disable-line no-console
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const failureLogger = (store) => (next) => (action) => {
  if (shouldIgnore(action.type)) {
    return next(action);
  }
  if (action?.type?.toLowerCase().includes('_failure')) {
    console.warn(`Failure action. Logging to bugsnag`);
    notify(new Error(`Redux Action Failed: ${action.type}`), (event) => {
      event.addMetadata(
        'ErrorContext',
        action.payload?.response?.data ?? action.payload?.message ?? action.payload.error
      );
    });
  }
  return next(action);
};
const middleware = [sagaMiddleware, failureLogger];

export let store = createStore(
  createRootReducer(history),
  composeEnhancers(applyMiddleware(routerMiddleware(history), ...middleware))
);

export let persistor = persistStore(store);

sagaMiddleware.run(rootSaga);
